import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-4 text-sm font-semibold" }
const _hoisted_2 = {
  key: 0,
  class: "border bg-white rounded mb-4"
}

import { computed, onMounted, PropType, ref, watch } from 'vue';
import { IOption, ManagementDestinationOption, ManagementStepField } from '@/lib';
import { ManagementPlanStepSelected } from '@/models';
import { BaseButton } from '@/lib/components/Button';
import ManagementPlanStep from './ManagementPlanStep.vue';
import { i18n } from '@/i18n/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementPlanStepAdder',
  props: {
  title: {
    type: String,
    default(): string {
      return i18n.global.t('custom.uhb.management.next-steps') as string;
    }
  },
  singularItemName: {
    type: String,
    default(): string {
      return i18n.global.t('custom.uhb.management.step') as string;
    }
  },
  fields: {
    type: Array as PropType<ManagementStepField[]>,
    default: () => []
  },
  value: {
    type: Array as PropType<ManagementStepField[][]>,
    default: () => []
  },
  destinations: {
    type: Array as PropType<ManagementDestinationOption[]>,
    default: () => []
  },
  timeframes: {
    type: Array as PropType<IOption[]>,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ["deleteStep", "addStep", "updateStep", "showError"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const steps = ref<ManagementStepField[][]>([]);
const errors = ref<Record<number, boolean>>({});

const isValid = computed(() => Object.values(errors.value).reduce((acc, isError) => acc && !isError, true));
const selectedCombinations = computed<Array<ManagementPlanStepSelected>>(() => props.value.reduce((acc, step) => {
  if (step[0].value && step[1].value) {
    acc.push({
      destination_id: step[0].value,
      timeframe_id: step[1].value
    });
  }
  return acc;
}, [] as Array<ManagementPlanStepSelected>));


watch(() => props.value, () => init(), { deep: true });
const removeStep = (stepIndex: number): void => {
  const id = steps.value[stepIndex][0].step_id;
  if (id) {
    emit('deleteStep', { step_id: id });
  } else {
    const newSteps = [...steps.value];
    newSteps.splice(stepIndex, 1);
    steps.value = newSteps;
  }
  delete errors.value[stepIndex];
  emit('showError', !isValid.value);
};
const addStep = (params: ManagementPlanStepSelected): void => {
  emit('addStep', params);
};
const updateStep = (params: ManagementPlanStepSelected): void => {
  emit('updateStep', params);
};
const appendStep = (): void => {
  steps.value.push(props.fields);
};
const setError = (index: number, value: boolean) => {
  errors.value[index] = value;
  emit('showError', value);
};
onMounted(() => {
  init();
});
const init = () => {
  steps.value = props.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
    (steps.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, stepIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stepIndex,
              class: _normalizeClass({
          'border-t': stepIndex
        })
            }, [
              _createVNode(ManagementPlanStep, {
                value: steps.value[stepIndex],
                destinations: __props.destinations,
                timeframes: __props.timeframes,
                "selected-combinations": selectedCombinations.value,
                "step-index": stepIndex,
                loading: __props.loading,
                onShowError: ($event: any) => (setError(stepIndex, $event)),
                onAddStep: addStep,
                onRemoveStep: removeStep,
                onUpdateStep: updateStep
              }, null, 8, ["value", "destinations", "timeframes", "selected-combinations", "step-index", "loading", "onShowError"])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(BaseButton), {
      class: "text-sm font-medium",
      "left-icon": "add",
      color: "ghost",
      disabled: selectedCombinations.value.length !== steps.value.length || !isValid.value,
      onClick: appendStep
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('platform.common.add-', [__props.singularItemName])), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})